export type HiddenArenaLevelId = 'expansion_1' | 'expansion_2' | 'ninja_kid';

const HIDDEN_ARENA_PATHS: Readonly<Record<string, HiddenArenaLevelId>> = {
  '/hidden/verdant-still': 'expansion_1',
  '/hidden/starfall-conduit': 'expansion_2',
  '/hidden/ninja-kid': 'ninja_kid',
};

const HIDDEN_ARENA_QUERIES: Readonly<Record<string, HiddenArenaLevelId>> = {
  'verdant-still': 'expansion_1',
  'starfall-conduit': 'expansion_2',
  'ninja-kid': 'ninja_kid',
};

/** Resolve only the private family routes. Public pages never read arena overrides. */
export function resolveHiddenArenaLevel(
  pathname: string,
  searchParams: URLSearchParams,
): HiddenArenaLevelId | null {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const pathLevel = HIDDEN_ARENA_PATHS[normalizedPath];
  if (pathLevel !== undefined) return pathLevel;

  if (normalizedPath !== '/hidden' && normalizedPath !== '/hidden.html') return null;
  const arena = searchParams.get('arena');
  return arena === null ? null : (HIDDEN_ARENA_QUERIES[arena] ?? null);
}

export function isPrivateExpansionPath(pathname: string): boolean {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return HIDDEN_ARENA_PATHS[normalizedPath] !== undefined;
}

export function shouldForcePrivateAbilities(
  hiddenVariant: boolean,
  levelId: string | null,
): boolean {
  return (
    hiddenVariant &&
    (levelId === 'expansion_1' || levelId === 'expansion_2' || levelId === 'ninja_kid')
  );
}
